import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type ThisApi = ApiDefinition['/payments/{paymentId}/refunds']['POST'];

type Input = ThisApi['params'] & ThisApi['body'];
type Output = ThisApi['response'];

const refundPayment = async ({ paymentId, amount }: Input): Promise<Output> => {
  const path = buildPath<ThisApi>('/payments/{paymentId}/refunds', { paymentId });
  const response = await noodleApiClient.post(path, { amount });
  return response.data;
};

export default refundPayment;
